"use client";

import { motion } from "framer-motion";

export default function PageBanner({ title, description, Icon }) {
  return (
    <section className="relative py-16 lg:py-24 overflow-hidden border-b-4 border-[#006699]">
      {/* SCOPED BACKGROUND */}
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: "url('/bg.webp')",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundAttachment: "fixed",
        }}
      />

      {/* BLUE OVERLAY */}
      <div
        className="absolute inset-0 z-0"
        style={{
          background: "linear-gradient(135deg, rgba(0,102,153,0.88) 0%, rgba(0,34,51,0.95) 100%)",
        }}
      />

      <div className="max-w-7xl mx-auto px-6 sm:px-10 relative z-10">
        <div className="flex items-center justify-between gap-12">
          <div className="flex items-stretch gap-6 md:gap-8 max-w-2xl">
            {/* Softened Vertical Accent Line */}
            <motion.div 
              initial={{ scaleY: 0 }}
              animate={{ scaleY: 1 }}
              transition={{ duration: 0.8, ease: "circOut" }}
              className="w-[3px] bg-[#7dd3fc] hidden md:block"
            />
            
            <div className="flex flex-col justify-center">
              <motion.h1
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                className="text-3xl sm:text-4xl md:text-5xl font-medium text-white mb-3 tracking-widest uppercase"
              >
                {title}
              </motion.h1>
              
              <motion.p
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.4 }}
                className="text-sm md:text-base text-white/80 font-light max-w-xl leading-relaxed tracking-wide"
              >
                {description}
              </motion.p>
            </div>
          </div>

          <motion.div
            initial={{ opacity: 0, scale: 0.9, x: 20 }}
            animate={{ opacity: 1, scale: 1, x: 0 }}
            transition={{ duration: 1, delay: 0.3 }}
            className="text-[#7dd3fc] drop-shadow-[0_0_15px_rgba(125,211,252,0.3)] w-24 h-24 sm:w-32 sm:h-32 md:w-40 md:h-40 lg:w-48 lg:h-48 flex-shrink-0 flex items-center justify-center opacity-40 lg:opacity-100 absolute right-[-20px] top-1/2 -translate-y-1/2 lg:relative lg:right-auto lg:top-auto lg:translate-y-0"
          >
            {Icon && <Icon size="100%" strokeWidth={1} />}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
